<template>
  <div class="product-container" id="container">
    <nav class="nav-header">
      <p @click="$router.push({name: 'company-admin-dids-local-did'})"
          :class="($route.name === 'company-admin-dids-local-did' 
            || $route.name === 'company-admin-dids-toll-free' || $route.name === 'company-admin-dids-buy-tf-did' || $route.name === 'company-admin-dids-buy-did') ? 'active' : ''" class="first">All DIDs</p>
      <p @click="$router.push({name: 'company-admin-dids-suppression'})"
          :class="($route.name === 'company-admin-dids-suppression') ? 'active' : ''">Suppression</p>
    </nav>
    <router-view class="router-container" />
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.product-container {
    padding: 0 20px;
}
.product-container .nav-header {
    margin: 0 -20px;
}
.product-container {
  .nav-header {
    height: 50px;
    background-color: #fff;
    // padding: 0px 20px 0px 20px;
    display: flex;
    p {
      cursor: pointer;
      width: auto;
      height: calc(100% - 2px);
      display: flex;
      align-items: center;
      margin-right: 10px;
      margin-bottom: 0;
      color: #BDBFD8;
      font-family: ""Helvetica Neue"";
      font-size: 16px;
      font-weight: 300;
      line-height: 20px;
      text-align: center;
      padding: 0 16px;
    }
    .active {
      color: #51a3f3;
      border-bottom: 2px solid #51a3f3;
    }
    .first {
      margin-left: 15px;
    }
  }
}
</style>

